import "./global.scss";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./redux/store";
import { login } from "./api";
import { loadCustomer, setToken } from "./redux/actions";
import { Provider } from "react-redux";

(async function main() {
  const state = store.getState();

  // Users must be always authenticated
  // TODO: Move the authentication to the back end
  if (!state.authorization.token) {
    const result = await login(window.location.href);
    if (result.redirect) {
      window.location = result.redirect;
      return;
    } else if (result.token) {
      store.dispatch(setToken(result.token, result.expireAt));
      store.dispatch(loadCustomer());
    }
  }

  // Users mush have a SFDC opportunity and a customer group
  // or are jumping from SFDC
  if (
    (state.opportunity && state.quote.customerGroupId) ||
    RegExp("/cpq/index/quote/oid/").test(window.location.pathname)
  ) {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById("root")
    );
  } else {
    window.location = state.returnUrl;
  }
})();
